import { Maximize, PictureInPicture2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const actionButtonClassName = 'flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-secondary text-foreground transition-colors hover:bg-accent'

interface PlayViewControlsProps {
	onFullscreen: () => void
	onTheaterToggle: () => void
	isTheaterMode: boolean
}

export function PlayViewControls({ onFullscreen, onTheaterToggle, isTheaterMode }: PlayViewControlsProps) {
	return (
		<div className='flex items-center gap-2'>
			<button type='button' onClick={onFullscreen} className={cn(actionButtonClassName, 'hidden md:flex')} aria-label='Enter fullscreen'>
				<Maximize className='h-4 w-4' />
			</button>
			<button
				type='button'
				onClick={onTheaterToggle}
				className={cn(actionButtonClassName, isTheaterMode && 'border-primary/40 bg-primary/10 text-primary')}
				aria-label='Toggle theater mode'
				aria-pressed={isTheaterMode}
			>
				<PictureInPicture2 className='h-4 w-4' />
			</button>
		</div>
	)
}

export { actionButtonClassName }
